import Icon from '@ant-design/icons';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useContextUsers } from '../../../../context/users';
import { Info, Logo, LogOut } from '../../../Common/Icon';

import MenuCommon from './Menu';
import { useAuth } from '../../../../context/auth';

import styles from '../../index.module.less';
import MortgageMakerTutorialModal from '../../../Common/MortgageMakerTutorialModal';

function SiderCommon(): JSX.Element {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);
  const { profile, getProfile } = useContextUsers();
  const [showTutorialModal, setShowTutorialModal] = useState<boolean>(location.state?.isFirstLogin ?? false);

  useEffect(() => {
    if (profile || !getProfile) return;

    getProfile();
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/sign-in');
  };

  const toggleTutorialModal = () => {
    setShowTutorialModal(prev => !prev);
  };

  return (
    <div className={styles.siderContent}>
      {showTutorialModal && <MortgageMakerTutorialModal open={showTutorialModal} onClose={toggleTutorialModal} />}
      <div className={clsx('flex-col w-100 d-m-flex d-lg-none', { [styles.opened]: isMenuOpened })}>
        <div className={styles.siderRow}>
          <Link to="/" className={styles.logo}>
            <Logo />
          </Link>
          <div
            className={clsx(styles.hamburger, { [styles.checked]: isMenuOpened })}
            onClick={() => setIsMenuOpened((prev) => !prev)}
          >
            <div className={styles.line} />
            <div className={styles.line} />
            <div className={styles.line} />
          </div>
        </div>
        <div className={styles.menuWrapper}>
          <div className={styles.menuContainer}>
            <div className={styles.menuContent}>
              <MenuCommon />
            </div>
            <Button
              type="ghost"
              icon={<Icon component={Info} />}
              size="large"
              className={styles.menuButton}
              onClick={toggleTutorialModal}
            >
              Tutorial
            </Button>
            <Button
              type="ghost"
              icon={<Icon component={LogOut} />}
              size="large"
              onClick={handleLogout}
              className={styles.menuButton}
            >
              Log Out
            </Button>
          </div>
          {profile && (
            <div className={styles.userBox}>
              <Typography.Title level={3} className={styles.userName}>
                {profile?.firstName} {profile?.lastName}
              </Typography.Title>
              <img className={styles.userAvatar} src={profile?.avatar || '/avatar-placeholder.png'} alt="Avatar" />
            </div>
          )}
        </div>
      </div>
      <div className={clsx(styles.sider, 'd-lg-grid', 'd-m-none')}>
        <Link to="/" className={styles.logo}>
          <Logo />
        </Link>
        <MenuCommon />
        <Button
          type="ghost"
          icon={<Icon component={Info} />}
          size="large"
          onClick={toggleTutorialModal}
        >
          Tutorial
        </Button>
        <Button type="ghost" icon={<Icon component={LogOut} />} size="large" onClick={handleLogout}>
          Log Out
        </Button>
      </div>
    </div>
  );
}

export default SiderCommon;
